import { CHANGED_INDEX, TOGGLED_FULLSCREEN } from "./types";

const initialState = {
  blogIndexInView: 1,
  fullscreen: false
};

export function interactiveMapReducer(state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case CHANGED_INDEX:
      return {
        ...state,
        blogIndexInView: payload.nextIndex
      };
    case TOGGLED_FULLSCREEN:
      return {
        ...state,
        fullscreen: !state.fullscreen
      };
    default:
      return state;
  }
}
